export default __webpack_public_path__ + "static/media/mint-a-prick-blue.95c029d1.svg";